import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=4a1c610b&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=4a1c610b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c610b",
  null
  
)

export default component.exports